import { appBankIcon } from './bank';
import { appSafeIcon } from './safe';
export const financeIcons = [appBankIcon, appSafeIcon];
